(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-active-competition.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-active-competition.js');
"use strict";

const {
  useCompetition,
  useActiveCompetitionId
} = svs.components.marketplaceCompetition.services.hooks;
const useActiveCompetition = () => useCompetition(useActiveCompetitionId());
setGlobal('svs.components.marketplaceCompetition.services.hooks.useActiveCompetition', useActiveCompetition);

 })(window);